var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "range" }, [
    _c("input", {
      staticClass: "fluid-slider",
      attrs: { id: "range-slider", type: "range", min: _vm.min, max: _vm.max },
      domProps: { value: _vm.value },
      on: { input: _vm.moveLabel, change: _vm.handleChange }
    }),
    _c("span", {
      staticClass: "range__label black",
      attrs: { id: "range-label" }
    }),
    _c(
      "div",
      { staticClass: "grid" },
      _vm._l(_vm.scale, function(s) {
        return _c(
          "div",
          { staticClass: "range__scaleMark", attrs: { "data-index": s } },
          [_c("p", { staticClass: "text-small black" }, [_vm._v(_vm._s(s))])]
        )
      }),
      0
    ),
    _c("div", { staticClass: "range__val range__val--min" }, [
      _c("div", { staticClass: "range__val__wrapper" }, [
        _c("p", { staticClass: "text-small black" }, [
          _vm._v(_vm._s(_vm.$t("common.min")))
        ]),
        _c("p", { staticClass: "text-small red" }, [
          _vm._v(_vm._s(_vm.min) + "€")
        ])
      ])
    ]),
    _c("div", { staticClass: "range__val range__val--max" }, [
      _c("div", { staticClass: "range__val__wrapper" }, [
        _c("p", { staticClass: "text-small black" }, [
          _vm._v(_vm._s(_vm.$t("common.max")))
        ]),
        _c("p", { staticClass: "text-small red" }, [
          _vm._v(_vm._s(_vm.max) + "€")
        ])
      ])
    ]),
    _c("div", { staticClass: "range__val range__val--standard" }, [
      _c("div", { staticClass: "range__val__wrapper" }, [
        _c("p", { staticClass: "text-small black" }, [
          _vm._v(_vm._s(_vm.$t("common.standard")))
        ]),
        _c("p", { staticClass: "text-small blueDark" }, [
          _vm._v(_vm._s(_vm.standard) + "€")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }